import { AcceptanceReason } from '@qas/smartcompose-tslibrary/dist/src/smartComposeInteraction';
import store from '../store/store';
import updateTelemetryForSuggestionOnSuggestionAccepted from '../telemetryHelpers/updateTelemetryForSuggestionOnSuggestionAccepted';
import updateRecentlyRejectedSuggestionsTelemetryWithSuggestionEventuallyAccepted from '../telemetryHelpers/updateRecentlyRejectedSuggestionsTelemetryWithSuggestionEventuallyAccepted';
import { logSuggestionAccepted } from '../telemetryHelpers/logDatapoints';
import replaceSuggestionInEditorWithRealText from '../utils/replaceSuggestionInEditorWithRealText';
import { setCurrentlyShownSuggestion } from '../actions/smartComposePluginActions';
import { IEditor } from 'roosterjs-editor-types';
import { ISmartComposeSession } from '@qas/smartcompose-tslibrary/dist/src/session';

// Accept the suggestion: take the currently suggeseted suggestion, remove if from the greyed out span
// and insert the text node into the document for real, and then update the insertion point
export default function acceptSuggestion(
    editor: IEditor,
    reason: AcceptanceReason,
    currentSmartComposeSession: ISmartComposeSession,
    keyPressedForAccept: number
) {
    const currentlyShownSuggestion = store().viewState.currentlyShownSuggestion;
    if (!currentlyShownSuggestion) {
        return;
    }

    updateTelemetryForSuggestionOnSuggestionAccepted(
        currentlyShownSuggestion.suggestionTelemetry,
        currentlyShownSuggestion.suggestionText,
        reason
    );
    updateRecentlyRejectedSuggestionsTelemetryWithSuggestionEventuallyAccepted(
        currentlyShownSuggestion.suggestionText
    );
    logSuggestionAccepted(
        currentlyShownSuggestion.suggestionTelemetry,
        currentSmartComposeSession,
        keyPressedForAccept
    );
    replaceSuggestionInEditorWithRealText(editor, currentlyShownSuggestion.suggestionNode);

    setCurrentlyShownSuggestion(null);
}
